import * as React from "react";
import "../Styles/style.css";

export default function ReturnsRefunds() {
  return (
    <>
      <div className='infoMainConatiner py-5'>
        <div className='container'>
          <h4 className='termsMainHeading pb-2'>Refund Policy</h4>

          <div className='infoMainBody py-3 px-5'>
            <p>
              A refund policy acting as the minority of your competitors can be
              one of the most efficient tools to draw away customers, as it
              provides them with security and promotes the brand name. However,
              the provider should go with a balanced policy to serve as a
              deterrent to customers.
            </p>

            <h5>Bidding</h5>
            <p>
              We provide an online auction site, whereby, we grant full refunds
              should any disputes arise exchanged between sellers and buyers.
              The Claim Form completed by the Policyholders together with the
              Policyholder's Details should be emailed to us. And then, the
              investigating unit of our department will do an audit of the
              specifications. This audit will be filed before the panel within a
              span of 2-3 working days. The fame wheel being the biggest concept
              for us, it's claim is under our top priority and the best
              practices are implemented from time to time.{" "}
            </p>
            <br />
            <h5>Examples :</h5>
            <p>
              <ol type='1' className='d-flex flex-column gap-2'>
                <li>
                  Our live car auction has space for a lot of bidders, and
                  titles will be given to the highest bidders. That other bidder
                  might also file a complaint, in this case we will also put our
                  best foot forward to investigate it.
                </li>

                <li>
                  Before the particular car can be bid on it will be inspected
                  and a document that will indicate the level of the defects
                  will be issued. The bid will be based on this level of
                  imperfections. The vehicles delivered by Fame Wheels SMC Pvt
                  Limited will be authenticated. Thus condition of the car will
                  also be ascertained before delivery. Buyers can request for a
                  warranty of our service charges within 24 hours in case of any
                  problems caused during processing of paperwork and/or
                  inspection.
                </li>
                <li>
                  Persons can also withdraw the subscription charges of 5000 for
                  a convenient cause like a conflict.
                </li>
                <li>
                  Once a productive bid has been placed, the given value will be
                  transferred to the statement of accounts of Fame Wheels SMC
                  Ltd. In a situation whereby both parties does a disagreement
                  in silhouetting the transaction process, we will definitely
                  refund the paid amount within seven days of verifying the
                  whole transaction process.
                </li>
              </ol>

              <span>
                Bidding Security Deposit (Refundable if dispute claim
                justified):
              </span>

              <br />
              <br />

              <ol type='1' className='d-flex flex-column gap-2'>
                <li>
                  Vehicles priced from 1 to 10 lakhs: Security deposit of 10,000
                  PKR
                </li>
                <li>
                  Vehicles priced from 10 to 25 lakhs: Security deposit of
                  20,000 PKR
                </li>
                <li>
                  Vehicles priced from 25 to 50 lakhs: Security deposit of
                  30,000 PKR
                </li>
                <li>
                  Vehicles priced from 50 to 75 lakhs: Security deposit of
                  40,000 PKR
                </li>
                <li>
                  Vehicles priced from 75 lakhs to 1 crore: Security deposit of
                  50,000 PKR
                </li>
                <li>
                  Vehicles priced over 1 crore: Security deposit of 100,000 PKR
                </li>
              </ol>
            </p>
            <br />
            <h5>Inspection</h5>
            <p>
              Among the services that our team of our professional inspectors
              offer is that we take part in inspections, conforming to the
              customers' requirements, using inspection tools and the support of
              IT apps. In case of any occurrence of problems concerning the
              inspection report, customers are welcome to ask for an amount of
              money half the paid amount by checking the form and sending email.
              We are seeking to investigate this issue to provide the refund we
              owe you.
            </p>

            <h5>Partial refunds are granted (if applicable):</h5>
            <p>
              Upon getting your refund application, we will send back to you an
              email notifying you already their receipt. Further, we shall also
              inform you of the acceptance or rejection of the refund that you
              request. If your refund is approved, the payment will appear on
              your credit card or initial methods of payment, and the process is
              usually within a certain number of days.
            </p>

            <h5>Late or missing refunds:</h5>

            <p>
              Check your bank account now and try to connect to your credit card
              company in order to get your refund. In case you’ve completed
              everything as indicated above and see no refunds, feel free to
              reach us by mail (mailbox details) and/or phone number.
            </p>

            <br />
            <h5>Feature Ads</h5>
            <p>
              <ol type='1' className='d-flex flex-column gap-2'>
                <li>
                  We, the society, stress for enforcing the highest standards in
                  business. Advertisements that are the feature will be
                  displayed on top of commercial lists on the market without the
                  competition or privilege. This will be 100% refundable if the
                  customer disagrees with the placement and the visibility on
                  the website of our company as one of the top listings on the
                  website.
                </li>
                <li>
                  The price of Fame Wheels ads varies upon selected features and
                  the amount listed on{" "}
                  <a href='https://famewheels.com' target='_blank'>
                    Fame Wheels
                  </a>{" "}
                  site.
                </li>
                <li>
                  Claimants need to fill the return form with all the details
                  and send it to us through email or scanner by date of claim on
                  priority basis. The desired division will undertake the
                  inquiry, and we will send the report along the findings to you
                  within 2-3 working days. Fame Wheels SMC Pvt Limited we are a
                  trustworthy business following the highest business principles
                  which include any and every claim.
                </li>
              </ol>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
